import ReactTippy, { TippyProps } from '@tippyjs/react';
import { ReactNode } from 'react';

import { SasIconButton } from '../SasIcon';

import { TippyThemes } from './TippyThemes';

export type TippyInstance = {
  show: () => void;
  hide: () => void;
};

type Props = Omit<TippyProps, 'content' | 'theme' | 'onClickOutside'> & {
  theme?: 'light' | 'error';
  content: string | ReactNode;
  handleClose: () => void;
};

export const Tippy = ({ content, handleClose, theme = 'light', ...tippyProps }: Props) => (
  <>
    <TippyThemes />
    <ReactTippy
      {...tippyProps}
      theme={theme}
      interactive
      onClickOutside={() => {
        handleClose();
      }}
      content={
        <>
          {typeof content === 'string' ? <p className="reset">{content}</p> : <div>{content}</div>}
          <SasIconButton
            onClick={() => {
              handleClose?.();
            }}
            name={'cl--close'}
            className="tippy-close-button"
            dimensions={{ width: '20px', height: '20px' }}
          />
        </>
      }
    >
      {tippyProps.children}
    </ReactTippy>
  </>
);
